import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    filters: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
})
export default class CustomCampaignFiltersComponent extends Vue {
  defaulProvinceSelected = true;

  changeFilters(key, value) {
    if (key === 'province') {
      this.defaulProvinceSelected = false;
    }
    if (key === 'price_range') {
      this.filters.map(filter => {
        if (filter.name === key) {
          filter.options.map(option => {
            if (option.name < 0) {
              option.name = 0;
            }
            return;
          });
        }
      });
    }
    this.$emit('change-filters',key, value);
  }

  get provinceSelected() {
    return this.defaulProvinceSelected;
  }
}
